import { render, staticRenderFns } from "./general-warning.vue?vue&type=template&id=2065fca1&scoped=true&"
import script from "./general-warning.vue?vue&type=script&lang=js&"
export * from "./general-warning.vue?vue&type=script&lang=js&"
import style0 from "./general-warning.vue?vue&type=style&index=0&id=2065fca1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065fca1",
  null
  
)

export default component.exports